import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useAuthContext } from "@context-providers/auth/auth-context";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { UserMenuEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The logout button for mobile layout in account settings */
export function LogoutButtonMobile() {
  const $ = _c(6);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    logout
  } = useAuthContext();
  let t0;
  if ($[0] !== logout || $[1] !== trackEvent) {
    t0 = function onLogoutClick() {
      trackEvent({
        name: UserMenuEvents.logOut,
        props: {
          from: "account-settings"
        }
      });
      logout();
    };
    $[0] = logout;
    $[1] = trackEvent;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onLogoutClick = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "text.primary",
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      width: "100%",
      justifyContent: "flex-start",
      p: "8px",
      mt: "4px"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onLogoutClick) {
    t2 = <FaroTextButton sx={t1} onClick={onLogoutClick}>Log out</FaroTextButton>;
    $[4] = onLogoutClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}